<template>
  <iframe :src=url></iframe>
</template>

<script>
export default {
  data() {
    const id = this.$route.query.id || this.$store.state.psId;
    const code = this.$route.query.code || this.$store.state.psCode || id;

    if (id) {
      this.$store.commit('SetPS', { id, code });
    }

    return {
      url: "/overview?id=" + id + "&code=" + code + "&role=" + this.$store.state.user.role,
    }
  }
};
</script>

<style scoped>
  iframe {
    width: 100%;
    height: 100%;
  }
</style>
